import {Component, Inject, OnInit} from "@angular/core";
import {
  AlertService,
  AuthenticationService,
  ComplianceAreaService,
  ControlItemsService,
  ProjectService
} from "../../_services";
import {Router} from "@angular/router";
import {LoginHelper, Recurring, StringsHelper} from "../../helpers";
import {ControlItem, Project, User} from "../../_models";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    standalone: false,
  selector: "select-control-item",
  templateUrl: 'select-control-item.component.html',
  styleUrls: ['./select-control-item.component.scss'],
})
export class SelectControlItemComponent implements OnInit {
  complianceAreas: Project[] = [];
  currentUser: User;
  rowGroupMetadata :any= {};
  expandedItems = {};

  cols : any[] = [
    {'field': 'complianceAreaControlId', 'header': 'Control ID'},
    {'field': 'category', 'header': 'Category'},
    {'field': 'description', 'header': 'Description'},
  ]


  constructor(
    public complianceAreaService: ComplianceAreaService,
    public router: Router,
    public authenticationService: AuthenticationService,
    public controlItemService: ControlItemsService,
    public alertService: AlertService,
    public dialogRef: MatDialogRef<SelectControlItemComponent>) {
  }

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.complianceAreaService.getComplianceAreas().subscribe(i => {
      this.complianceAreas = i;
    });

  }

  getControlItems(event){
    if (event.data.controlItems && event.data.controlItems.length) {
      return event.data.controlItems;
    }
    event.data.loading = true;
    this.controlItemService.getComplianceAreaControlItems(event.data.complianceAreaId)
      .subscribe(controlItems => {
          event.data.loading = false;
          event.data.controlItems = controlItems.filter(i => !i.parentControlItemId);;
          this.updateRowGroupMetaData(event.data.complianceAreaId, event.data.controlItems);
        },
        error => {
          const message = "An error occurred while loading items.";
          this.alertService.error(message);
        });
  }
  selectControlItem(data)
  {
    this.dialogRef.close(data);
  }

  updateRowGroupMetaData(complianceAreaId, data) {
    this.rowGroupMetadata[complianceAreaId] = {};
    if (data) {

      for (let i = 0; i < data.length; i++) {
        let rowData = data[i];
        let brand = rowData.category;
        if (i == 0) {
          this.rowGroupMetadata[complianceAreaId][brand] = {index: 0, size: 1};
        } else {
          let previousRowData = data[i - 1];
          let previousRowGroup = previousRowData.category;
          if (brand === previousRowGroup)
            this.rowGroupMetadata[complianceAreaId][brand].size++;
          else
            this.rowGroupMetadata[complianceAreaId][brand] = {index: i, size: 1};
        }
      }
    }
  }

}
